const datepicker = require('pikaday');

class DatePicker {
  constructor() {
    let datepickerElement = document.querySelector('.js-datepicker');
    if(!datepickerElement) {
      datepickerElement = document.querySelector('.js-datepicker-wrapper input');
    }

    if(datepickerElement) {
      new datepicker({
        field: datepickerElement,
        format: 'MM/DD/YYYY',
        position: 'top',
        minDate: new Date()
      });
    }
  }
}

export default DatePicker;
